import { NBSP } from 'shared/constants/symbols';

export const STEPS = [
  {
    id: 1,
    title: `Войдите или зарегистрируйтесь на${NBSP}Циан`,
    image: 'first-step',
    description: ['Любым удобным способом'],
  },
  {
    id: 2,
    title: 'Перейдите к размещению объявления',
    imageUrl: 'https://static.cdn-cian.ru/frontend/info-assets/hosts/screencast_1.gif',
    description: [
      'В кабинете выберите «Разместить»',
      ['Сделка —> Аренда', 'Аренда —> Посуточная', 'Объект —> Выберите тип'],
      'Введите адрес',
    ],
  },
  {
    id: 3,
    title: `Примите условия работы с${NBSP}онлайн-бронированием`,
    imageUrl: 'https://static.cdn-cian.ru/frontend/info-assets/hosts/screencast_2.gif',
    description: ['Заполните ваши данные для отчётности и чеков, подключите бесплатное страхование объекта'],
  },
  {
    id: 4,
    title: 'Завершите создание объявления',
    imageUrl: 'https://static.cdn-cian.ru/frontend/info-assets/hosts/screencast_3.gif',
    description: ['Заполните параметры объекта, описание, фото и стоимость', 'Опубликуйте объявление (это бесплатно)'],
  },
  {
    id: 5,
    title: 'Настройте календарь',
    imageUrl: 'https://static.cdn-cian.ru/frontend/info-assets/hosts/screencast_4.gif',
    description: [
      'Перейдите к объявлению и настройте бесплатный календарь Циан',
      'Его можно синхронизировать с другими площадками, где вы размещаетесь',
    ],
  },
];
